import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solicitud',
  templateUrl: './solicitud.component.html',
  styleUrls: ['./solicitud.component.sass']
})
export class SolicitudComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
